import { render, staticRenderFns } from "./file-input.vue?vue&type=template&id=331a5005&"
import script from "./file-input.vue?vue&type=script&lang=js&"
export * from "./file-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('331a5005')) {
      api.createRecord('331a5005', component.options)
    } else {
      api.reload('331a5005', component.options)
    }
    module.hot.accept("./file-input.vue?vue&type=template&id=331a5005&", function () {
      api.rerender('331a5005', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/dataImport/components/file-input.vue"
export default component.exports